import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Extinguish',
    desc: 'Use the Day 1-3 "Cellular Flush" to clear inflammatory messengers from your blood.'
  }, {
    num: '2',
    title: 'Stabilize',
    desc: 'Introduce "Hormonal Anchors" on Day 4-7 to lock in your progress and cool the joints.'
  }, {
    num: '3',
    title: 'Maintain',
    desc: 'Transition to the 80/20 Menopause Rule to keep the "fire" from ever returning.'
  }];
  return <section className="py-24 px-6 bg-cream" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <FadeIn data-id="element-122">
          <h2 className="text-3xl md:text-4xl text-teal mb-16 text-center" data-id="element-123">
            How It Works
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-124">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-sage/30 z-0" data-id="element-125"></div>

            {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-126">
                <div className="w-24 h-24 rounded-full bg-teal text-white flex items-center justify-center text-3xl font-serif mb-6 shadow-lg border-4 border-cream" data-id="element-127">
                  {step.num}
                </div>
                <h3 className="text-2xl font-serif text-teal mb-4" data-id="element-128">
                  {step.title}
                </h3>
                <p className="text-charcoal/80 text-lg leading-relaxed" data-id="element-129">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}